const columns = [
  {
    key: 'request_code',
    stickyColumn: true,
    isRowHeader: true,
    label: 'Request Code',
  },
  { key: 'source_date', label: 'Allocation Date' },
  { key: 'certificate_name_en', label: 'Certificate' },
  { key: 'sub_certificate_name', label: 'Sub Certificate' },
  { key: 'first_reviewer_name', label: 'first reviewer' },
  { key: 'first_reviewer_allocation_date', label: 'F.R Allocation Date' },
  { key: 'second_reviewer_name', label: 'second reviewer' },
  { key: 'second_reviewer_allocation_date', label: 'S.R Allocation Date' },
  { key: 'categoryRequestNo', label: 'category Req. No' },
  { key: 'status', label: 'Last Status' },
  { key: 'enternal_status', label: 'Application Status' },
  { key: 'source', label: 'Source' },
  { key: 'certificate_number', label: 'Certificate Number' },
  { key: 'expired_at', label: 'Expired At' },
  { key: 'issued_at', label: 'Issued At' },
  { key: 'last_status_update', label: 'Last Status Update' },
  { key: 'due_date', label: 'Due Date' },
  { key: 'facility_name', label: 'Facility Name' },
  { key: 'client_name', label: 'Requester' },
  { key: 'payment_status', label: 'Payment Status' },
  { key: 'office_name', label: 'Office' },
  { key: 'inspector', label: 'Inspector' },
  { key: 'inspector_allocation_date', label: 'Inspector Allocation Date' },
  { key: 'application_reviewer', label: 'Decision Maker' },
  {
    key: 'application_reviewer_allocation_date',
    label: 'D.M Allocation Date',
  },
  { key: 'markter', label: 'Markter' },
  { key: 'markter_allocation_date', label: 'Markter Allocation Date' },
]

export default columns
